<mat-card class="card" appearance="outlined" [attr.aria-label]="label">
  <h5 class="card-label">{{ label }}</h5>
  <mat-card-content class="card-content">
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
